module.exports = __webpack_public_path__ + "img/01.3dd2dd17.png";